import { Component, OnInit, inject, signal } from '@angular/core';
import {
  SessionLibService,
  AppCommonsModule,
  AvatarModel,
} from '@nutricontrol/app360-shared';
import { AppCommonsService } from '../../app-commons.service';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { TranslationsLibService } from '@nutricontrol/app360-shared';
import { Title } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  imports: [IonicModule, AppCommonsModule],
})
export class MainHeaderComponent implements OnInit {
  private session = inject(SessionLibService);
  router = inject(Router);
  private title = inject(Title);
  private route = inject(ActivatedRoute);
  private commonsService = inject(AppCommonsService);
  translationsLib = inject(TranslationsLibService);

  readonly name = signal('');
  readonly avatar = signal<AvatarModel | null>(null);
  readonly breadcrumb = signal('');

  ngOnInit() {
    this.avatar.set(this.session.getAvatar());
    if (document.location.href.includes('breadcrumb')) {
      let link = document.location.href;
      link = link.split('=')[1];
      this.breadcrumb.set(this.translationsLib.get(link));
    }
    this.router.events.subscribe((val) => {
      if (document.location.href.includes('breadcrumb')) {
        let link = document.location.href;
        link = link.split('=')[1];
        this.breadcrumb.set(this.translationsLib.get(link));
      } else {
        this.breadcrumb.set('');
      }
      if (val instanceof ActivationEnd) {
        this.setTitleFromKey(val.snapshot.data?.title);
      }
    });
    const r = this.router.config.find(
      (route) =>
        route.path === (this.router.url.split('/')[1] || 'my-ucrop-home')
    );
    this.setTitleFromKey(r?.data?.title);
  }

  private setTitleFromKey(titleKey?: string) {
    if (!titleKey) {
      return;
    }

    let bc_key = titleKey;
    if (bc_key === 'billing-addresses') {
      bc_key = 'billing_addresses';
    }

    this.name.set(this.translationsLib.get(bc_key));
    if (this.breadcrumb() !== '') {
      this.title.setTitle(
        'MyUCROP | ' + this.name() + ' | ' + this.breadcrumb()
      );
    } else {
      this.title.setTitle('MyUCROP | ' + this.name());
    }
  }
}
